import React from 'react'
import { observer } from 'mobx-react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { getStyles } from '../../../utils/utils/commonUtils'
import mainMenuItemStyles from '../styles/mainMenuItemStyles'

import { ListItem, useTheme } from '@mui/material'
import { useLocation, useNavigate } from 'react-router-dom'

const startsWithRoutes = ['/service-reports', '/reports']
const exceptions = ['/reports-summary']

function MainMenuItem({ name, route, handleClick, toggleMenu, isChild }) {
  const theme = useTheme()
  const navigate = useNavigate()
  const location = useLocation()
  const classes = getStyles(mainMenuItemStyles)

  const active =
    route === location.pathname ||
    (startsWithRoutes.includes(route) &&
      location.pathname?.startsWith(route) &&
      !exceptions.includes(location.pathname))

  const onPageChange = () => {
    navigate(route)
    toggleMenu()
  }

  return (
    <ListItem
      onClick={handleClick || onPageChange}
      sx={{
        width: '100%',
        height: '100%',
        padding: '0!important',
        marginY: isChild ? '5px' : undefined,
      }}
    >
      <Typography
        component={'div'}
        color={theme.palette.gray.light}
        sx={{
          width: '100%',
          height: '100%',
          padding: '12px 20px 12px 64px',
          backgroundColor: active
            ? theme.palette.blue.menuSelected
            : 'transparent',
          fontSize: '18px',
          fontWeight: 400,
          paddingLeft: isChild ? '78px' : undefined,
          ...classes.menuLink,
        }}
      >
        {name}
      </Typography>
    </ListItem>
  )
}

export default observer(MainMenuItem)
